module.exports = __webpack_public_path__ + "static/suburban-a6a539627265533cd976711e7371c9ec.webp";